export function SortTh({ i, sort, className, testid, children }) {
  const on = sort.s.c === i;
  const go = () => sort.cycle(i);
  return (
    <th className={(className ? className + " " : "") + "sortable"} tabIndex={0} data-testid={testid}
      aria-sort={on ? (sort.s.d === "asc" ? "ascending" : "descending") : undefined}
      onClick={go} onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(); } }}>
      {children}{on ? <span className="sort-ind" aria-hidden="true">{sort.s.d === "asc" ? " ▲" : " ▼"}</span> : null}
    </th>
  );
}
